import React from 'react';
import {isRouteErrorResponse, useRouteError} from 'react-router';

/**
 * Last-resort `ErrorBoundary` export for `root.tsx`. Errors inside the app are handled by
 * `AppErrorBoundary` (brand `_error` page); this only renders when the shell itself fails,
 * so it must not depend on any app provider.
 */
const RootErrorBoundary = () => {
	const error = useRouteError();
	const status = isRouteErrorResponse(error) ? error.status : 500;

	return (
		<main style={{fontFamily: 'sans-serif', padding: '2rem', textAlign: 'center'}}>
			<h1>{status}</h1>
			<p>{status === 404 ? 'Page not found' : 'Something went wrong'}</p>
		</main>
	);
};

export default RootErrorBoundary;
